// extracted by mini-css-extract-plugin
export default {"app":"App_app__gQuxZ","panel":"App_panel__8UpWw","fadeUp":"App_fadeUp__Rdzhp","panelWorlds":"App_panelWorlds__jQ5ia"};